import CalendarHeader from './CalendarHeader.vue';

export default CalendarHeader;



// WEBPACK FOOTER //
// ./src/pages/profile/modules/remote-edu/calendar/components/calendar/components/calendarheader/index.ts